module.exports = __webpack_public_path__ + "static/media/videography-hero.df744bca.png";